//import renderShapes from './lib/renderCirkel';

const init = () => {
  //renderShapes();
};

init();



// WEBPACK FOOTER //
// ./src/js/script.js